import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { filter, first, mapTo } from 'rxjs/operators';
import { BcConfigService } from 'common/config/provider';
import { GenesysUserPermissionService } from 'common/store/genesys-cloud/users/services/user-permission.service';
import { GenesysCloudEmailConversationsModulePermissions } from '../initialize-module.permissions';
import { initializeModule } from '../actions/email-conversation.actions';

@Injectable({
  providedIn: 'root'
})
export class GenesysCloudEmailConversationsInitializeModuleEffects {
  readonly initializeModule$ = createEffect(() => this.userPermissionService.hasAnyPermission$(
    ...GenesysCloudEmailConversationsModulePermissions
  ).pipe(
    filter(Boolean),
    filter(() => this.configService.isGenesysEmailConversationEnabled()),
    first(),
    mapTo(initializeModule())
  ));

  constructor(private readonly configService: BcConfigService,
              private readonly userPermissionService: GenesysUserPermissionService) {
  }
}
